// extracted by mini-css-extract-plugin
module.exports = {"message":"styles_message__15w6w","active":"styles_active__Nqfwk"};